// extracted by mini-css-extract-plugin
module.exports = {"icon":"Hm_x3","iconWrapper":"_1wTe5"};